import { Box } from '@mui/material';
import { LayoutSwitcher } from 'components/shared/LayoutSwitcher';
import SearchInput from 'components/shared/SearchInput';
import { LayoutType } from 'model/deals.model';
import { SyntheticEvent } from 'react';

export const Filters = ({
  layout,
  onLayoutChange,
  value,
  debouncedValue,
  handleChange,
  clearInput,
}: {
  layout: LayoutType;
  onLayoutChange: (_: SyntheticEvent, newValue: LayoutType) => void;
  value: string;
  debouncedValue: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clearInput: () => void;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          gap: { xs: '8px', sm: '12px' },
          alignItems: 'center',
        }}
      >
        <Box sx={{ width: { xl: '240px', xs: '150px' } }}>
          <SearchInput value={value} handleChange={handleChange} clearInput={clearInput} />
        </Box>

        <LayoutSwitcher layout={layout} onLayoutChange={onLayoutChange} />
      </Box>
    </Box>
  );
};
